import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import app from 'srcJs/App';
import { Alert } from 'ui/alert/Alert';
import * as React from 'react';
import { FC } from 'react';

type Props = {
  onClose: () => void,
};

export const SentAlert: FC<Props> = ({ onClose }) => (
  <Alert variant={Variant.primary} dismissible onClose={onClose}>
    <p className="mb-0">
      {app.t('confirm_email_notifier', 'Confirmation Email has been sent!')}
    </p>
  </Alert>
);
